import { css, useTheme } from "@emotion/react";

// MIT License

// Copyright (c) 2020 Vineeth.TR

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

const FallingBars = () => {
    const theme = useTheme();
    const color = theme.isLightTheme
        ? theme.colors.black.light40.asHex
        : theme.colors.black.light60.asHex;
    const background = theme.colors.transparent.value.asHex;

    const styles = css`
        width: 45px;
        height: 40px;
        background:
            linear-gradient(
                ${color} calc(1 * 100% / 6),
                ${background} 0 calc(3 * 100% / 6),
                ${color} 0
            ),
            linear-gradient(
                ${color} calc(2 * 100% / 6),
                ${background} 0 calc(4 * 100% / 6),
                ${color} 0
            ),
            linear-gradient(
                ${color} calc(3 * 100% / 6),
                ${background} 0 calc(5 * 100% / 6),
                ${color} 0
            );
        background-size: 10px 400%;
        background-repeat: no-repeat;
        animation: matrix 2s infinite linear;
        @keyframes matrix {
            0% {
                background-position:
                    0% 100%,
                    50% 100%,
                    100% 100%;
            }
            100% {
                background-position:
                    0% 0%,
                    50% 0%,
                    100% 0%;
            }
        }
    `;
    return <div css={styles} />;
};

export { FallingBars };
